import classes from './FlexRowDiv.module.css';

const FlexRowDiv = (props) => {
    return (
        <div className={classes.flexRow}>{props.children}</div>
    )
};

export default FlexRowDiv;